<template>
    <div>
        <login :showConfirmedAccount="showConfirmedAccount"></login>
    </div>
</template>

<script>
    import Login from './Login'

    export default {
        data: function () {
            return {
                showConfirmedAccount: false
            }
        },
        created: function() {
            this.validateAccount();
        },
        methods: {
            validateAccount: function() {

                axios.get(axios.authURL + 'auth/Confirmation', { params: this.$route.query }).then(response => {
                    if (response && response.status === 200) {
                        // this.$toasted.success(response.data.message);
                        this.showConfirmedAccount = true
                    }
                    else {
                        this.$toasted.error(response.data.message);
                        this.showConfirmedAccount = false
                    }
                }).catch(err => {
                    this.$toasted.error(error.response.data.message);
                })
            }
        },
        components: {
            Login,
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// Confirmation.vue?884825e0